import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the PhonePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'phone',
})
export class PhonePipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(textToSearchPhone: string): string {

    let regex = new RegExp(/(\+34|0034|34)?[\s|\-|\.]?[6|7|8|9][\s|\-|\.]?([0-9][\s|\-|\.]?){8}/g, 'gi');

    textToSearchPhone = textToSearchPhone.replace(regex, (match) => `<a href="tel:${match}">${match}</a>`);

    return textToSearchPhone;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/phone/phone.ts